export type TransportRequestStatus = 'NEW' | 'ASSIGNED' | 'DONE' | 'CANCELLED';

export interface TransportRequestRow {
  id: number;
  number: string;
  status: TransportRequestStatus;
  departmentId: number | null;
  department: { id: number; name: string } | null;
  requesterName: string;
  requesterPhone: string | null;
  neededFrom: string;
  neededTo: string | null;
  vehicleCategory: string | null;
  passengers: number | null;
  cargoTons: string | null;
  fromPoint: string | null;
  toPoint: string | null;
  flightNumber: string | null;
  aircraftReg: string | null;
  standNumber: string | null;
  purpose: string | null;
  cancelReason: string | null;
  createdAt: string;
  task: {
    id: number;
    waybill: {
      id: number;
      number: string;
      status: string;
      vehicle: { id: number; garageNumber: string; plateNumber: string | null };
      driver: {
        id: number;
        employee: { lastName: string; firstName: string; middleName: string | null };
      };
    };
  } | null;
}

/** Цвет и подпись статуса заявки — одни и те же в таблице и в окнах. */
export const REQUEST_STATUS: Record<TransportRequestStatus, { label: string; color: string }> = {
  NEW: { label: 'Новая', color: 'processing' },
  ASSIGNED: { label: 'Назначена', color: 'gold' },
  DONE: { label: 'Выполнена', color: 'success' },
  CANCELLED: { label: 'Отменена', color: 'default' },
};

/**
 * Маршрут одной строкой. Поля те же, что у задания путевого листа, и что в
 * них лежит, решает раскладка задания офиса — поэтому просто склеиваем
 * заполненное: «откуда (уточнение) → куда».
 */
export function routeText(row: {
  fromPoint: string | null;
  toPoint: string | null;
  flightNumber: string | null;
  aircraftReg: string | null;
  standNumber: string | null;
}): string {
  const from = [row.flightNumber, row.fromPoint, row.aircraftReg, row.standNumber]
    .filter(Boolean)
    .join(', ');
  if (from && row.toPoint) return `${from} → ${row.toPoint}`;
  return from || row.toPoint || '—';
}
